export default __webpack_public_path__ + "static/media/pci-dss.7fecb505.jpeg";